import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import AppBar from './components/AppBar'
import Footer from './components/Footer'
import { Col, Container, Row } from 'react-bootstrap'
import { Buttons } from '../components/Buttons/Buttons'
import { useNavigate } from 'react-router-dom';
import { MagicStar,HeartTick,Quant,Tag2} from 'iconsax-react';
import MetaTags from './components/MetaTags';
const About = () => {
    const navigate = useNavigate();
    const handlenavigate = () => {
        navigate('/');
    }
    useEffect(() => {
        AOS.init({
            offset: 200,    // Offset (in px) from the original trigger point
            delay: 0,       // Values from 0 to 3000, with step 50ms
            duration: 4000, // Values from 0 to 3000, with step 50ms
            easing: 'ease', // Default easing for AOS animations
            mirror: true,  // Whether elements should animate out while scrolling past them
          });
      }, []);
  return (
    <>
      <MetaTags
        title="About Us - Suguna Crackers | Sivakasi Wholesale Fireworks Manufacturer"
        description="Learn about Suguna Crackers, Sivakasi leading direct factory wholesale & retail fireworks supplier. High quality, legal safety standards, festive discounts & transport dispatch."
        keywords="about suguna crackers, sivakasi crackers manufacturer, wholesale fireworks dealer, safe crackers sivakasi"
        url="https://sugunacrackers.com/about"
      />
        <AppBar/>
        <img src={require('../assets/images/banner_one.jpg')} className='img-fluid w-100' alt='product name' />
            <>
            <div className='padding'>
                <Container>
                    <Row>
                        <Col lg='6' className='py-3 align-self-center'>
                            <span className='contact-header-badge mb-2'>About Suguna Crackers</span>
                            <h2 className='bold mb-2'>Premium Sivakasi Fireworks</h2>
                            <h5 className='bold text-danger mb-3'>Direct Factory Wholesale & Retail Godown</h5>
                            <div className='regular'>
                                <p>Welcome to <strong>Suguna Crackers</strong>, your trusted destination for <strong>high-quality crackers in both retail and wholesale</strong>! As one of the leading fireworks suppliers in the Sivakasi region, we offer an extensive variety of crackers ranging from <strong>sparklers, rockets, flower pots, and chakkars to grand festival gift boxes</strong>.</p>

                                <p>We cater to all occasions — including <strong>Diwali, New Year, weddings, and temple festivals</strong>. We proudly maintain the <strong>highest safety and statutory standards</strong>, ensuring products that are vibrant, eco-conscious, and safe to use.</p>

                                <p>Whether you need small family packs or <strong>bulk wholesale orders</strong>, we guarantee <strong>unmatched factory pricing with reliable transport delivery</strong>.</p>
                            </div>
                        </Col>
                        <Col lg="6" className='py-3 text-center'>
                            <img src={require('../assets/images/about.png')} className='img-fluid' alt='product'/>
                        </Col>
                    </Row>
                </Container>
            </div>
               
                <div className='counter padding bg-overlay z'>
                    <Container>
                            <Row>
                                <Col lg="12" className='py-3 text-center z'>
                                     <h4 className='bold text-white mb-3'>We have handpicked your favorite crackers in our pricelist. Check our festival deals now!</h4>

                                     <Buttons label={<>View Price List</>} onClick={handlenavigate}/>
                                </Col>
                            </Row>
                    </Container>
                </div>
                
                <Container className='padding'>
                    <Row>
                        <Col lg="4" md="6" xs="12" className='py-3'>
                            <div className='text-center py-5' data-aos="zoom-in-right">
                                <div className='choose' data-aos="zoom-in-left">
                                <Quant
                                    size="32"
                                    color="#555555"
                                    />
                                </div>
                                    <h2 className="bold mt-3">Quality</h2>
                                    <p className="regular">Manufacturing <strong>Quality Crackers & innovation</strong> are the keys behind our trust.</p>
                            </div>
                            <div className='text-center py-5' data-aos="zoom-in-right">
                                <div className='choose' >
                                <Tag2
                                    size="32"
                                    color="#555555"
                                    />
                                </div>
                                    <h2 className="bold mt-3">Affordable Price</h2>
                                    <p className="regular">Safe, compliant fireworks manufactured with <strong>top-grade raw materials at factory rates</strong>.</p>
                            </div>
                        </Col>

                        <Col lg="4" md="6" xs="12" className='align-self-center'>
                            <img src={require('../assets/images/chottabeam.gif')} className='img-fluid chutti' alt='product' data-aos="zoom-in"/>
                        </Col>
                        <Col lg="4" md="6" xs="12" className='py-3'>
                            <div className='text-center py-5' data-aos="flip-left">
                                <div className='choose'>
                                 <MagicStar size="32" color="#555555"/>
                                </div>
                                    <h2 className="bold mt-3">Safe To Use</h2>
                                    <p className="regular">All crackers we offer are <strong>100% safe, green compliant</strong> and crafted from fine-grade raw materials.</p>
                            </div>
                            <div className='text-center py-5' data-aos="flip-right">
                                <div className='choose'>
                                <HeartTick
                                    size="32"
                                    color="#555555"
                                    />
                                </div>
                                    <h2 className="bold mt-3">100% Satisfaction</h2>
                                    <p className="regular">Our <strong>consistent quality and express delivery</strong> ensure memorable celebrations every time.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <img src={require('../assets/images/aboutbanner.jpg')} className='img-fluid w-100' alt='product'/>
            </>
        <Footer/>
    </>
  )
}

export default About